import { produce } from '../helpers';
import { TPContext } from '../types';

type LastCommentsRead = {
    [rowId: string]: Date;
};

type CommentsViews = {
    [viewKey: string]: LastCommentsRead;
};

export type CommentsContext = {
    comments: CommentsViews;
    readonly setComments: (viewKey: string, rowId: string, lastRead: Date) => void;
};

export const commentsContext: TPContext<CommentsContext> = (set, get, api) => {
    return {
        comments: {},
        setComments: (viewKey, rowId, lastRead) => {
            set(
                produce(store => {
                    if (!store.comments[viewKey]) {
                        store.comments[viewKey] = {};
                    }
                    store.comments[viewKey][rowId] = lastRead;
                }),
            );
        },
    };
};